export default import.meta.ROLLDOWN_FILE_URL_YhNCc8kPC3cxGCL$BOC21A